import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { IconButton, SwipeableDrawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { ROUTES } from '../../../utils/constants';
import { NavUser } from '../NavUser';
import { OptionsMenu } from '../OptionMenu';
import { Divider } from '../../Divider';
import { LogoLink } from '../../Logo';
import { NavigateBefore } from '@mui/icons-material';
import { CJRLogo, LogoPositions } from '../../CJRLogo';

type HeaderProps = {
  foo?: string;
};

export const Header = ({ foo }: HeaderProps) => {
  const location = useLocation();
  const editPattern = new RegExp(ROUTES.users.edit('\\d+'));
  const isHomePage = location.pathname === ROUTES.home;
  const hideHeader =
    location.pathname === ROUTES.users.create ||
    location.pathname === ROUTES.users.me ||
    editPattern.test(location.pathname);

  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerOpen = () => setOpenDrawer(true);
  const handleDrawerClose = () => setOpenDrawer(false);

  if (hideHeader) return null;

  return (
    <div
      className={clsx(
        'flex flex-row items-center gap-4',
        'sticky md:static z-10 top-0',
        'w-full box-border',
        { 'bg-white md:bg-transparent': !isHomePage }
      )}
    >
      {isHomePage && (
        <div
          className={clsx(
            'flex flex-row w-full px-6 py-2',
            'justify-between items-center'
          )}
        >
          <LogoLink width={130} height={130} />
          <NavUser />
        </div>
      )}

      {!isHomePage && (
        <div
          className={clsx(
            'flex flex-col justify-between',
            'w-full h-full px-6',
            'bg-blue-desaturated/50 md:bg-transparent'
          )}
        >
          <div className="flex items-center py-3">
            <div className="h-min block md:hidden">
              <IconButton aria-label="Abrir menu" onClick={handleDrawerOpen}>
                <MenuIcon />
              </IconButton>
            </div>

            <div
              className={clsx(
                'hidden md:flex',
                'flex-row w-full',
                'justify-end items-center'
              )}
            >
              <NavUser />
            </div>
          </div>

          <Divider className="hidden md:block" />
        </div>
      )}

      {/* mobile hamburger menu */}
      <SwipeableDrawer
        className="md:hidden"
        anchor="left"
        open={openDrawer}
        onClose={handleDrawerClose}
        onOpen={handleDrawerOpen}
        keepMounted
      >
        <div className={clsx('flex flex-col', 'h-full')}>
          <div className="flex items-center justify-between px-6 py-4">
            <LogoLink onClick={handleDrawerClose} />

            <IconButton
              aria-label="Fechar menu"
              onClick={handleDrawerClose}
              size="large"
            >
              <NavigateBefore />
            </IconButton>
          </div>

          <Divider />

          <div
            className={clsx(
              'flex flex-col items-start',
              'gap-2 px-6 py-4 h-full',
              'overflow-auto scroll-thin'
            )}
          >
            <OptionsMenu drawer onOptionClick={handleDrawerClose} />
          </div>
          <CJRLogo logoPosition={LogoPositions.MOBILENAVBAR} />

          <Divider />

          <div className="px-6 py-4">
            <NavUser color="secondary" />
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};
